import type { SessionKind } from '@/shared/api'
import type { IconName } from '@/shared/ui/icon'

export interface NavItem {
  label: string
  icon: IconName
  to: string
}

// Разделы сотрудника. «Отчёты» — сводка времени команды на созвонах; у заказчика
// её нет ни здесь, ни на бэке.
export const NAV_ITEMS: NavItem[] = [
  { label: 'Встречи', icon: 'camera', to: '/meetings' },
  { label: 'Отчёты', icon: 'chart', to: '/reports' },
]

// У заказчика своя витрина и своё имя раздела: «встречи команды» клиенту
// компании ничего не говорят, а попасть в них он и не вправе.
export const CUSTOMER_NAV_ITEMS: NavItem[] = [
  { label: 'Мои созвоны', icon: 'camera', to: '/my/meetings' },
]

export function navFor(kind: SessionKind): NavItem[] {
  return kind === 'customer' ? CUSTOMER_NAV_ITEMS : NAV_ITEMS
}
